module.exports = __webpack_public_path__ + "img/settings.035abd3c.svg";